import { render, staticRenderFns } from "./ElementsList.vue?vue&type=template&id=86f1d97e&"
import script from "./ElementsList.vue?vue&type=script&lang=js&"
export * from "./ElementsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports